import './Loading.scss'
import React from 'react'

export const Loading = () => {
  return <div className="c-Loading">
    <div className="spinner"></div>
  </div>
}
